import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const TopbarContainer = styled(Box)(`
  display: flex;
  align-items: center;
  height: 56px;
  background-color: #F6F6F5;
  padding: 0px 20px;
  gap: 20px;
  width: auto;
  transition: all 0.5s; // FullScreening
`)

export const LogoText = styled('img')(`
  height:30px;
`)

export const PageTitle = styled(Box)(`
  font-size: 19px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  flex: 1;
  font-weight: 400;
  text-align:start;
  color: #1C1B1F;
  line-height: 1;
`)

export const PageSubTitle = styled('span')(`
  color: #686867;
  font-weight: 400;
  display: flex;
  line-height: 1;
  height: 30px;
  align-items: center;
  margin-left: 8px;
  padding-left:27px;
  position: relative;

  &:before {
    content: '';
    display: block;
    transform: rotate(45deg);
    width: 10px;
    height: 10px;
    border-right: 1px #000 solid;
    border-top: 1px #000 solid;
    position: absolute;
    top: 10px;
    left: 0;
  }
`)

export const StudyTitle = styled(Box)(`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  display:flex;
  flex-direction: column;
  width:100%;
`)

export const StudySubTitle = styled(Box)(`
  color: #000;
  font-size:  14px;
  font-weight: 400;
  line-height: 17px;
`)

export const Actions = styled(Box)(`
  display: flex;
  align-items: center;

  & > * {
    margin-left: 12px;
  }
`)
